import { useEffect, useRef } from 'react';
import { FJ_COMMON_VIEW } from '../../redux/slice/FJCommonSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import useLocalStore from '../../hooks/useLocalStore';
import { FJGeneratingPageAction } from '../../redux/action/FJGeneratingPageAction';
import FJGeneratingPage from './FJGeneratingPage';
import FJRequirementsUtil from '@src/util/FJRequirementsUtil';

export default function FJGeneratingPageContainer() {
    useLocalStore();
    const dispatch = useAppDispatch();
    const visible = useAppSelector(state => state.common.activeView === FJ_COMMON_VIEW.GENERATING);
    const overallProgress = useAppSelector(state => state.generatingPage.overallProgress);
    const video = useAppSelector(state => state.generatingPage.video);
    const wasVisibleRef = useRef(false);
    const lastProgressRef = useRef(0);

    useEffect(() => {
        lastProgressRef.current = overallProgress;
    }, [overallProgress]);

    useEffect(() => {
        if (visible) {
            if (!wasVisibleRef.current) {
                FJRequirementsUtil.eaLog('long_to_shorts_generate_page_view');
            }
            wasVisibleRef.current = true;
        } else {
            if (wasVisibleRef.current) {
                FJRequirementsUtil.eaLog('long_to_shorts_generate_page_close', {
                    progress: lastProgressRef.current,
                });
            }
            wasVisibleRef.current = false;
        }
    }, [visible]);

    if (!visible) {
        return null;
    }

    return (
        <FJGeneratingPage
            overallProgress={overallProgress}
            video={video}
            onBack={() => dispatch(FJGeneratingPageAction.backToHomeFromGeneratingAction())}
        />
    );
}
